import React, { useState } from 'react';
import { ArrowLeft, Truck } from 'lucide-react';
import VehicleInspection from '../components/vehicles/VehicleInspection';
import { useAuth } from '../contexts/AuthContext';

const VehicleInspectionPage = ({ vehicleId, inspectionType = 'pre-trip', onBack }) => {
  const { userData } = useAuth();

  // Mock vehicle data
  const getVehicleInfo = (id) => ({
    1: { vehicleNumber: 'T-001', make: 'Kenworth', model: 'T680', year: 2022 },
    2: { vehicleNumber: 'T-002', make: 'Freightliner', model: 'Cascadia', year: 2021 },
    3: { vehicleNumber: 'TR-001', make: 'Great Dane', model: 'Dry Van', year: 2020 },
    4: { vehicleNumber: 'V-001', make: 'Ford', model: 'Transit', year: 2023 },
    5: { vehicleNumber: 'T-003', make: 'Volvo', model: 'VNL', year: 2022 }
  });

  const vehicle = getVehicleInfo(vehicleId)?.[vehicleId] || {
    vehicleNumber: `V-${vehicleId}`,
    make: 'Unknown',
    model: 'Vehicle',
    year: 2023
  };

  const [inspectionCompleted, setInspectionCompleted] = useState(false);

  const handleInspectionComplete = (inspectionData) => {
    setInspectionCompleted(true);
    console.log('Inspection completed:', inspectionData);
    // Here you would typically save to backend
    
    // Auto-return to previous page after 3 seconds
    setTimeout(() => {
      if (onBack) {
        onBack();
      }
    }, 3000);
  };

  if (inspectionCompleted) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full mx-4">
          <div className="text-center">
            <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-green-100 mb-4">
              <svg className="h-6 w-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              Inspection Completed!
            </h2>
            <p className="text-gray-600 mb-4">
              {inspectionType === 'pre-trip' ? 'Pre-trip' : 'Post-trip'} inspection for {vehicle.vehicleNumber} has been successfully completed and saved.
            </p>
            <p className="text-sm text-gray-500">
              Returning to vehicle list in 3 seconds...
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              {onBack && (
                <button
                  onClick={onBack}
                  className="inline-flex items-center px-3 py-2 border border-gray-300 rounded-lg text-sm text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  <ArrowLeft className="h-4 w-4 mr-2" />
                  Back to Vehicles
                </button>
              )}
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-blue-100 rounded-lg">
                  <Truck className="h-6 w-6 text-blue-600" />
                </div>
                <div>
                  <h1 className="text-xl font-semibold text-gray-900">
                    {inspectionType === 'pre-trip' ? 'Pre-Trip' : 'Post-Trip'} Inspection
                  </h1>
                  <p className="text-sm text-gray-600">
                    {vehicle.vehicleNumber} - {vehicle.year} {vehicle.make} {vehicle.model}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <VehicleInspection
          vehicleId={vehicleId}
          inspectionType={inspectionType}
          onInspectionComplete={handleInspectionComplete}
        />
      </div>
    </div>
  );
};

export default VehicleInspectionPage;